import { Component, OnInit } from '@angular/core';
import { JeevesProductDetailsComponent } from 'gung-standard-jeeves';
import { ActivatedRoute } from '@angular/router';
import {
  ProductService,
  AvailabilityService,
  AuthService,
  PriceService,
  GungFlowService,
  MetadataService,
  AssortmentService
} from 'gung-standard';
import { environment } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
    selector: 'ref-ref-product-details',
    templateUrl: './ref-product-details.component.html',
    styleUrls: ['./ref-product-details.component.scss'],
    standalone: false
})
export class RefProductDetailsComponent extends JeevesProductDetailsComponent implements OnInit {
  isCapstone = environment.projectName === 'capstone';
  isAdminOrSales: boolean = false;

  constructor(
    protected route: ActivatedRoute,
    protected productService: ProductService,
    protected availabilityService: AvailabilityService,
    protected authService: AuthService,
    protected priceService: PriceService,
    protected translateService: TranslateService,
    protected gungFlowService: GungFlowService,
    metadataService: MetadataService,
    assortmentService: AssortmentService
  ) {
    super(
      route,
      productService,
      availabilityService,
      authService,
      priceService,
      translateService,
      gungFlowService,
      metadataService,
      assortmentService
    );
  }
  
  ngOnInit() {
    super.ngOnInit();
    this.authService.getRoles().pipe(first()).subscribe(roles => {
      this.isAdminOrSales = roles.includes('ADMIN') || roles.includes('SALES');
    });
  }
}
